module.exports = __webpack_public_path__ + "static/img/hero-wave.3e6782f3.svg";